import {
  MEMBER,
  SIGN_OUT,
} from '../actions/constants';

const initialState = {
  handling: false,
  data: {},
};

export default function member(state = initialState, action) {
  switch (action.type) {
    case MEMBER.handlers.fetch:
    case MEMBER.handlers.update:
    case MEMBER.handlers.remove:
      return {
        ...state,
        handling: true,
      };
    case MEMBER.update:
      return {
        ...state,
        data: action.merge ? {
          ...state.data,
          ...action.data,
        } : action.data,
        handling: false,
      };
    case SIGN_OUT:
      return initialState;
    default:
      return state;
  }
}
